import React from "react";
import styles from "./fields.module.css";

export interface TextFieldProps {
  id?: string;
  label: string;
  value: string;
  type?: "text" | "email" | "tel" | "number" | "date" | "textarea";
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  icon?: React.ReactNode;
}

export const TextField: React.FC<TextFieldProps> = ({
  id,
  label,
  value,
  type = "text",
  onChange,
  onBlur,
  placeholder,
  required,
  disabled,
  error,
  icon,
}) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onChange(e.target.value);
  };

  const isTextarea = type === "textarea";
  const baseClass = isTextarea ? styles.textarea : styles.input;
  const inputClassName = `${baseClass} ${icon ? styles.inputWithIcon : ""} ${error ? styles.inputError : ""}`;

  return (
    <div className={styles.container}>
      <label className={styles.label} htmlFor={id}>
        {label} {required && <span className={styles.required}>*</span>}
      </label>
      {isTextarea ? (
        <textarea
          id={id}
          className={inputClassName}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          rows={3}
        />
      ) : (
        <div className={styles.inputWrapper}>
          {icon && <span className={styles.iconPrefix}>{icon}</span>}
          <input
            id={id}
            type={type}
            className={inputClassName}
            value={value}
            onChange={handleChange}
            onBlur={onBlur}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
          />
        </div>
      )}
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};
